import { render, staticRenderFns } from "./PagesTabsWidget.vue?vue&type=template&id=1e2eb394&"
import script from "./PagesTabsWidget.vue?vue&type=script&lang=js&"
export * from "./PagesTabsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports